import React, { useState } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router-dom';

import { useApiQuery } from '../../hooks/useApiQuery';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useShowNotification } from '../../hooks/useShowNotification';
import { get as getOrder, update as updateOrder } from '../../apis/orders';

import { AdminBreadcrumb } from '../../components/admin/AdminBreadcrumb';
import { OrderForm } from '../../components/orders/OrderForm';
import { LoadingBlocker } from '../../components/common/ui/LoadingBlocker';
import { OrderFormLoading } from '../../components/orders/OrderFormLoading';

export const EditOrderPage = () => {
    useDocumentTitle('Edit Order');

    const { id } = useParams();
    const navigate = useNavigate();
    const order = useApiQuery(getOrder, id);
    const [isLoading, setIsLoading] = useState(false);
    const showNotification = useShowNotification('Orders', 'file-invoice');

    const handleSubmit = async (form) => {
        try {
            setIsLoading(true);

            const orderItems = form.items.map((item) => ({
                ...item,
                price: item.product.price,
                product: item.product.id
            }));

            const response = await updateOrder({
                id,
                ...form,
                items: orderItems
            });
            setIsLoading(false);

            if (!response.success) {
                showNotification(response.message, 'warning');
                return;
            }

            showNotification(response.message, 'success');
            navigate(`/admin/orders`);
        } catch (error) {
            setIsLoading(false);
            showNotification('Oops something went wrong.', 'danger');
        }
    };

    const handleReset = () => {
        navigate('/admin/orders');
    };

    return (
        <div className="edit-order-page mb-5">
            <h1 className="h3">Edit order</h1>
            <AdminBreadcrumb>
                <NavLink className="breadcrumb-item text-decoration-none" to="/admin/orders">
                    Orders
                </NavLink>
                <p className="breadcrumb-item text-muted text-decoration-none mb-0">Edit</p>
            </AdminBreadcrumb>
            {order.hasData && (
                <OrderForm
                    className={isLoading ? 'd-none' : ''}
                    model={order.data.record}
                    onSubmit={handleSubmit}
                    onReset={handleReset}
                    mode="edit"
                />
            )}
            {order.isLoading && (
                <React.Fragment>
                    <OrderFormLoading />
                    <LoadingBlocker text="Loading order..." />
                </React.Fragment>
            )}
            {isLoading && (
                <React.Fragment>
                    <OrderFormLoading />
                    <LoadingBlocker text="Updating order..." />
                </React.Fragment>
            )}
        </div>
    );
};
